import { useSearchParams } from '@/hooks/useSearchParams';
import { useGetCalendarEvent } from '@/queries/calendar-event.queries';
import { ICalendar } from '@/types/ICalendar';
import { ICalendarEvent } from '@/types/calendar-event/ICalendarEvent';

interface IArgs {
	calendar: ICalendar;
	event: ICalendarEvent | null;
}

export function useEventDetailsController(args: IArgs) {
	const params = useSearchParams();
	const id = params.get('event-id') as string;

	const query = useGetCalendarEvent({ id, enabled: !!id || !!args.event });

	return {
		event: args.event || query.data,
		query,
	};
}
